/* eslint-disable */
/* tslint:disable */

import {
	ActualThreatParams,
	ActualThreatResponse,
	ActualThreatUpdateParams,
	ActualViolatorParams,
	ActualViolatorResponse,
	Application,
	BasicTacticResponse,
	BusinessProcessEditParams,
	BusinessProcessInfoResponse,
	BusinessProcessPatternAddIdsRequestParams,
	BusinessProcessPatternInfoResponse,
	BusinessProcessPatternNameAndComment,
	BusinessProcessPatternRequestParams,
	BusinessProcessPatternResponse,
	BusinessProcessPatternSearchRequestParams,
	BusinessProcessResponse,
	CategorizationDocument,
	CategorizationDocumentResponse,
	CollusionGroupParams,
	CollusionGroupResponse,
	DamageObjectResponse,
	DocumentFolderParams,
	DocumentFolderResponse,
	EconomicalDamageParams,
	EconomicalDamageResponse,
	HistoryEntry,
	ImplementThreatWayParams,
	ImplementThreatWayResponse,
	InfluenceObjectParams,
	InfluenceObjectResponse,
	Integer,
	ObjectParams,
	OrganizationCardResponse,
	OrganizationDocumentParams,
	OrganizationDocumentResponse,
	OrganizationMarkersList,
	OrganizationObjectDocumentResponse,
	OrganizationObjectInfoResponse,
	OrganizationObjectParams,
	OrganizationObjectResponse,
	OrganizationObjectStatusResponse,
	OrganizationObjectThreatResponse,
	OrganizationOkvedResponse,
	OrganizationSimpleResponse,
	OrganizationUpdateParams,
	ProcessParams,
	RiskTypeParams,
	RiskTypeResponse,
	String,
	SystemDescriptionParams,
	SystemDescriptionResponse,
	SystemMeanEditParams,
	SystemMeanParams,
	SystemMeanResponse,
	ThreatFillStatusResponse,
	ThreatImplementationAssessmentParams,
	ThreatImplementationAssessmentResponse,
	ThreatImplementationLevelParams,
	ThreatImplementationLevelResponse,
	ThreatImplementationLevelUpdateParams,
	ThreatModelTemplateCreateRequest,
	ThreatModelTemplateResponse,
	UserGroupParams,
	UserGroupResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

class Organization<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
	/**
	 * No description
	 *
	 * @tags Организации
	 * @summary Карточка организации
	 * @request GET:/organization/{id}
	 * @secure
	 */
	organizationDetail = (id: number, params: RequestParams = {}) =>
		this.request<OrganizationCardResponse, void>({
			path: `/organization/${id}`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Организации
	 * @summary Редактирование организации
	 * @request PUT:/organization/{id}
	 * @secure
	 */
	organizationUpdate = (id: number, data: OrganizationUpdateParams, params: RequestParams = {}) =>
		this.request<OrganizationCardResponse, void>({
			path: `/organization/${id}`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Организации
	 * @summary Архивирование/разархивирование организации
	 * @request DELETE:/organization/{id}
	 * @secure
	 */
	organizationDelete = (
		id: number,
		query: {
			/** true - архивирование, false - разархивирование */
			archived: boolean;
		},
		params: RequestParams = {},
	) =>
		this.request<void, void>({
			path: `/organization/${id}`,
			method: "DELETE",
			query: query,
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Организации
	 * @summary Получить логотип организации
	 * @request GET:/organization/{id}/logo
	 * @secure
	 */
	logoDetail = (id: number, params: RequestParams = {}) =>
		this.request<File, void>({
			path: `/organization/${id}/logo`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Организации
	 * @summary Загрузка логотипа организации
	 * @request POST:/organization/{id}/logo
	 * @secure
	 */
	logoCreate = (
		id: number,
		data: {
			/** @format binary */
			file?: File;
		},
		params: RequestParams = {},
	) =>
		this.request<File, void>({
			path: `/organization/${id}/logo`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.FormData,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Организации
	 * @summary Загрузить документ субъекта КИИ
	 * @request POST:/organization/{id}/okii/doc
	 * @secure
	 */
	okiiDocCreate = (
		id: number,
		data: {
			/** @format binary */
			file?: File;
		},
		params: RequestParams = {},
	) =>
		this.request<any, void>({
			path: `/organization/${id}/okii/doc`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.FormData,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Организации
	 * @summary Получить список маркеров организации
	 * @request GET:/organization/{id}/markers
	 * @secure
	 */
	markersDetail = (id: number, params: RequestParams = {}) =>
		this.request<OrganizationMarkersList, void>({
			path: `/organization/${id}/markers`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Организации
	 * @summary Отметить маркеры организации
	 * @request POST:/organization/{id}/markers
	 * @secure
	 */
	markersCreate = (
		id: number,
		data: {
			/** @format binary */
			file?: File;
			idlist?: Integer[];
		},
		params: RequestParams = {},
	) =>
		this.request<OrganizationMarkersList, void>({
			path: `/organization/${id}/markers`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.FormData,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Организации
	 * @summary Получить список ОКВЭД организации
	 * @request GET:/organization/{id}/okved
	 * @secure
	 */
	okvedDetail = (id: number, params: RequestParams = {}) =>
		this.request<OrganizationOkvedResponse[], void>({
			path: `/organization/${id}/okved`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Организации
	 * @summary Редактирование ОКВЭД организации
	 * @request PUT:/organization/{id}/okved
	 * @secure
	 */
	okvedUpdate = (id: number, data: String[], params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/organization/${id}/okved`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.Json,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Организации
	 * @summary Получить список организаций, недоступных для отключения категорирования
	 * @request GET:/organization/{id}/categorizable
	 * @secure
	 */
	categorizableDetail = (id: number, params: RequestParams = {}) =>
		this.request<OrganizationSimpleResponse[], void>({
			path: `/organization/${id}/categorizable`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Организации
	 * @summary Включение уровня ведения категорирования
	 * @request POST:/organization/{id}/categorizable
	 * @secure
	 */
	categorizableCreate = (id: number, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/organization/${id}/categorizable`,
			method: "POST",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Организации
	 * @summary Выключение уровня ведения категорирования
	 * @request DELETE:/organization/{id}/categorizable
	 * @secure
	 */
	categorizableDelete = (id: number, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/organization/${id}/categorizable`,
			method: "DELETE",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Организации
	 * @summary Изменить статус категорирования
	 * @request GET:/organization/{id}/categorization-status
	 * @secure
	 */
	categorizationStatusDetail = (
		id: number,
		query: {
			/** новый статус */
			status: "NOT_CATEGORIZED" | "PRIMARY_STARTED" | "PRIMARY_DONE" | "SECONDARY_STARTED" | "SECONDARY_DONE";
		},
		params: RequestParams = {},
	) =>
		this.request<HistoryEntry[], void>({
			path: `/organization/${id}/categorization-status`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Организации
	 * @summary Получить список объектов ОКИИ
	 * @request GET:/organization/{id}/okii
	 * @secure
	 */
	okiiDetail = (
		id: number,
		query?: {
			/** Поисковый запрос */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<OrganizationObjectStatusResponse[], void>({
			path: `/organization/${id}/okii`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Документы организации
	 * @summary Получить папки организации
	 * @request GET:/organization/{id}/folders
	 * @secure
	 */
	foldersDetail = (
		id: number,
		query?: {
			archive?: boolean;
		},
		params: RequestParams = {},
	) =>
		this.request<DocumentFolderResponse[], void>({
			path: `/organization/${id}/folders`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Документы организации
	 * @summary Добавить папку организации
	 * @request POST:/organization/{id}/folders
	 * @secure
	 */
	foldersCreate = (id: number, data: DocumentFolderParams, params: RequestParams = {}) =>
		this.request<DocumentFolderResponse, void>({
			path: `/organization/${id}/folders`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Документы организации
	 * @summary Обновить папку организации
	 * @request PUT:/organization/folder/{id}
	 * @secure
	 */
	folderUpdate = (id: number, data: DocumentFolderParams, params: RequestParams = {}) =>
		this.request<DocumentFolderResponse, void>({
			path: `/organization/folder/${id}`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Документы организации
	 * @summary Архивирование/разархивирование папки организации
	 * @request DELETE:/organization/folder/{id}
	 * @secure
	 */
	folderDelete = (
		id: number,
		query: {
			archived: boolean;
		},
		params: RequestParams = {},
	) =>
		this.request<void, void>({
			path: `/organization/folder/${id}`,
			method: "DELETE",
			query: query,
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Документы организации
	 * @summary Список документов организации по-умолчанию
	 * @request GET:/organization/folder/{id}/docs
	 * @secure
	 */
	folderDocsDetail = (
		id: number,
		query?: {
			archived?: boolean;
		},
		params: RequestParams = {},
	) =>
		this.request<OrganizationDocumentResponse[], void>({
			path: `/organization/folder/${id}/docs`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Документы организации
	 * @summary Добавление документа
	 * @request POST:/organization/folder/{id}/docs
	 * @secure
	 */
	folderDocsCreate = (
		id: number,
		data: {
			params?: OrganizationDocumentParams;
			/** @format binary */
			file?: File;
		},
		params: RequestParams = {},
	) =>
		this.request<OrganizationDocumentResponse, void>({
			path: `/organization/folder/${id}/docs`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.FormData,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Документы организации
	 * @summary Получить документ организации
	 * @request GET:/organization/folder/doc/{id}
	 * @secure
	 */
	folderDocDetail = (id: number, params: RequestParams = {}) =>
		this.request<File, void>({
			path: `/organization/folder/doc/${id}`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Документы организации
	 * @summary Редактирование документа
	 * @request PUT:/organization/folder/doc/{id}
	 * @secure
	 */
	folderDocUpdate = (id: number, data: String, params: RequestParams = {}) =>
		this.request<OrganizationDocumentResponse, void>({
			path: `/organization/folder/doc/${id}`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.Text,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Документы организации
	 * @summary Загрузить новую версию документа
	 * @request POST:/organization/folder/doc/{id}
	 * @secure
	 */
	folderDocCreate = (
		id: number,
		data: {
			/** @format binary */
			file?: File;
		},
		params: RequestParams = {},
	) =>
		this.request<OrganizationDocumentResponse, void>({
			path: `/organization/folder/doc/${id}`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.FormData,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Документы организации
	 * @summary Архивирование/разархивирование документа
	 * @request DELETE:/organization/folder/doc/{id}
	 * @secure
	 */
	folderDocDelete = (
		id: number,
		query: {
			archived: boolean;
		},
		params: RequestParams = {},
	) =>
		this.request<void, void>({
			path: `/organization/folder/doc/${id}`,
			method: "DELETE",
			query: query,
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Документы организации
	 * @summary Получить список версий документа
	 * @request GET:/organization/folder/doc/{id}/versions
	 * @secure
	 */
	folderDocVersionsDetail = (
		id: number,
		query?: {
			archived?: boolean;
		},
		params: RequestParams = {},
	) =>
		this.request<OrganizationDocumentResponse[], void>({
			path: `/organization/folder/doc/${id}/versions`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Документы организации
	 * @summary Установить документ по-умолчанию
	 * @request POST:/organization/folder/doc/version/{id}
	 * @secure
	 */
	folderDocVersionCreate = (id: number, params: RequestParams = {}) =>
		this.request<OrganizationDocumentResponse, void>({
			path: `/organization/folder/doc/version/${id}`,
			method: "POST",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Документы организации
	 * @summary Получить список документов категорирования
	 * @request GET:/organization/{id}/docs/categorization
	 * @secure
	 */
	docsCategorizationDetail = (
		id: number,
		query: {
			/** @format int32 */
			objectId?: number;
			archived?: boolean;
			type: "ORDER" | "PROCESS" | "REGISTRY" | "ENUM" | "MODEL" | "RESULT" | "BUNDLE" | "LETTER";
		},
		params: RequestParams = {},
	) =>
		this.request<CategorizationDocument, void>({
			path: `/organization/${id}/docs/categorization`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Документы организации
	 * @summary Скачать документ категорирования
	 * @request GET:/organization/doc/{id}/categorization
	 * @secure
	 */
	docCategorizationDetail = (
		id: number,
		query: {
			type: "ORDER" | "PROCESS" | "REGISTRY" | "ENUM" | "MODEL" | "RESULT" | "BUNDLE" | "LETTER";
		},
		params: RequestParams = {},
	) =>
		this.request<File, void>({
			path: `/organization/doc/${id}/categorization`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Документы организации
	 * @summary Получить версии документа
	 * @request GET:/organization/doc/{id}/categorization/versions
	 * @secure
	 */
	docCategorizationVersionsDetail = (
		id: number,
		query: {
			type: "ORDER" | "PROCESS" | "REGISTRY" | "ENUM" | "MODEL" | "RESULT" | "BUNDLE" | "LETTER";
			archived?: boolean;
		},
		params: RequestParams = {},
	) =>
		this.request<CategorizationDocumentResponse[], void>({
			path: `/organization/doc/${id}/categorization/versions`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Бизнес-процессы
	 * @summary Получить список бизнес-процессов организации
	 * @request GET:/organization/{id}/processes
	 * @secure
	 */
	processesDetail = (id: number, params: RequestParams = {}) =>
		this.request<BusinessProcessResponse[], void>({
			path: `/organization/${id}/processes`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Бизнес-процессы
	 * @summary Добавление бизнес-процесса организации
	 * @request POST:/organization/{id}/process
	 * @secure
	 */
	processCreate = (id: number, data: BusinessProcessEditParams, params: RequestParams = {}) =>
		this.request<BusinessProcessResponse, void>({
			path: `/organization/${id}/process`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Бизнес-процессы
	 * @summary Сохранение измененного бизнес-процесса
	 * @request POST:/organization/process/{id}
	 * @originalName processCreate
	 * @duplicate
	 * @secure
	 */
	processCreate2 = (id: number, data: BusinessProcessEditParams, params: RequestParams = {}) =>
		this.request<BusinessProcessResponse, void>({
			path: `/organization/process/${id}`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Бизнес-процессы
	 * @summary Удаление бизнес-процесса
	 * @request DELETE:/organization/process/{id}
	 * @secure
	 */
	processDelete = (id?: number, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/organization/process/${id}`,
			method: "DELETE",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Бизнес-процессы
	 * @summary Получить список шаблонов бизнес-процессов
	 * @request POST:/organization/{id}/processes/patterns-info
	 * @secure
	 */
	processesPatternsInfoCreate = (
		data: BusinessProcessPatternSearchRequestParams,
		id?: number,
		params: RequestParams = {},
	) =>
		this.request<BusinessProcessPatternInfoResponse[], void>({
			path: `/organization/${id}/processes/patterns-info`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Бизнес-процессы
	 * @summary Получить информацию по шаблону
	 * @request GET:/organization/{id}/pattern/{pattern_id}/get
	 * @secure
	 */
	patternGetDetail = (patternId: number, id?: string, params: RequestParams = {}) =>
		this.request<BusinessProcessPatternResponse, void>({
			path: `/organization/${id}/pattern/${patternId}/get`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Бизнес-процессы
	 * @summary Создание шаблона бизнес-процессов из набора существующих бизнес процессов организации
	 * @request POST:/organization/{id}/processes/pattern
	 * @secure
	 */
	processesPatternCreate = (data: BusinessProcessPatternRequestParams, id?: string, params: RequestParams = {}) =>
		this.request<BusinessProcessPatternResponse, void>({
			path: `/organization/${id}/processes/pattern`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Бизнес-процессы
	 * @summary Редактирование ТОЛЬКО имени и комментария шаблона
	 * @request POST:/organization/{id}/processes/pattern/{pattern_id}/edit_credit
	 * @secure
	 */
	processesPatternEditCreditCreate = (
		patternId: number,
		data: BusinessProcessPatternNameAndComment,
		id?: number,
		params: RequestParams = {},
	) =>
		this.request<BusinessProcessPatternResponse, void>({
			path: `/organization/${id}/processes/pattern/${patternId}/edit_credit`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Бизнес-процессы
	 * @summary Редактирование шаблона реестра бизнес-процессов( для полного ПЕРЕЗАПОЛНЕНИЯ из существующих бизнес процессов)
	 * @request POST:/organization/{id}/processes/pattern/{pattern_id}/refill_bp
	 * @secure
	 */
	processesPatternRefillBpCreate = (
		patternId: number,
		data: BusinessProcessPatternRequestParams,
		id?: number,
		params: RequestParams = {},
	) =>
		this.request<BusinessProcessPatternResponse, void>({
			path: `/organization/${id}/processes/pattern/${patternId}/refill_bp`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Бизнес-процессы
	 * @summary Удаление шаблона реестра бизнес-процессов
	 * @request POST:/organization/{id}/processes/pattern/{pattern_id}/delete
	 * @secure
	 */
	processesPatternDeleteCreate = (patternId: number, id?: number, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/organization/${id}/processes/pattern/${patternId}/delete`,
			method: "POST",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Бизнес-процессы
	 * @summary Отключение шаблона реестра бизнес-процессов
	 * @request POST:/organization/{id}/processes/pattern/{pattern_id}/disable
	 * @secure
	 */
	processesPatternDisableCreate = (patternId: number, id?: number, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/organization/${id}/processes/pattern/${patternId}/disable`,
			method: "POST",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Бизнес-процессы
	 * @summary Включение(отменить статус архивного) шаблона реестра бизнес-процессов
	 * @request POST:/organization/{id}/processes/pattern/{pattern_id}/enable
	 * @secure
	 */
	processesPatternEnableCreate = (patternId: number, id?: number, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/organization/${id}/processes/pattern/${patternId}/enable`,
			method: "POST",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Бизнес-процессы
	 * @summary Удаление заготовленного элемента (бп) из шаблона
	 * @request POST:/organization/{id}/processes/pattern/item/{pattern_item_id}/delete
	 * @secure
	 */
	processesPatternItemDeleteCreate = (patternItemId: number, id?: number, params: RequestParams = {}) =>
		this.request<BusinessProcessPatternResponse, void>({
			path: `/organization/${id}/processes/pattern/item/${patternItemId}/delete`,
			method: "POST",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Бизнес-процессы
	 * @summary Редактирование заготовленного элемента (бп) из шаблона
	 * @request POST:/organization/{id}/processes/pattern/item/{pattern_item_id}/edit
	 * @secure
	 */
	processesPatternItemEditCreate = (
		patternItemId: number,
		data: BusinessProcessEditParams,
		id?: number,
		params: RequestParams = {},
	) =>
		this.request<BusinessProcessEditParams, void>({
			path: `/organization/${id}/processes/pattern/item/${patternItemId}/edit`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Бизнес-процессы
	 * @summary Добавление существующих бп в шаблон (копирование)
	 * @request POST:/organization/{id}/processes/pattern/{pattern_id}/import-bps
	 * @secure
	 */
	processesPatternImportBpsCreate = (
		patternId: number,
		data: BusinessProcessPatternAddIdsRequestParams,
		id?: number,
		params: RequestParams = {},
	) =>
		this.request<BusinessProcessPatternResponse, void>({
			path: `/organization/${id}/processes/pattern/${patternId}/import-bps`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Бизнес-процессы
	 * @summary Добавление нового эелемента в шаблон (ручное заполнение полей бп)
	 * @request POST:/organization/{id}/processes/pattern/{pattern_id}/create-bp-item
	 * @secure
	 */
	processesPatternCreateBpItemCreate = (
		patternId: number,
		data: BusinessProcessEditParams,
		id?: number,
		params: RequestParams = {},
	) =>
		this.request<BusinessProcessPatternResponse, void>({
			path: `/organization/${id}/processes/pattern/${patternId}/create-bp-item`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Бизнес-процессы
	 * @summary Добавление нового эелемента в шаблон (ручное заполнение полей бп)
	 * @request POST:/organization/{id}/processes/pattern/apply-pattern-items
	 * @secure
	 */
	processesPatternApplyPatternItemsCreate = (id: number, data: Integer[], params: RequestParams = {}) =>
		this.request<boolean, void>({
			path: `/organization/${id}/processes/pattern/apply-pattern-items`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Бизнес-процессы
	 * @summary Получить весь список шаблонов бизнес-процессов
	 * @request GET:/organization/processes/patternsAll
	 * @secure
	 */
	processesPatternsAllList = (params: RequestParams = {}) =>
		this.request<BusinessProcessPatternResponse[], void>({
			path: `/organization/processes/patternsAll`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Бизнес-процессы
	 * @summary Получить список подключенных и неподключенных объектов
	 * @request GET:/organization/{id}/process/{processID}/objects
	 * @secure
	 */
	processObjectsDetail = (id: number, processId: number, params: RequestParams = {}) =>
		this.request<OrganizationObjectInfoResponse[], void>({
			path: `/organization/${id}/process/${processId}/objects`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Бизнес-процессы
	 * @summary Привязать бизнес-процесс к объектам организации
	 * @request POST:/organization/{id}/process/{processID}/object
	 * @secure
	 */
	processObjectCreate = (id: number, processId: number, data: ObjectParams, params: RequestParams = {}) =>
		this.request<BusinessProcessResponse, void>({
			path: `/organization/${id}/process/${processId}/object`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Бизнес-процессы
	 * @summary Получить файл реестра БП
	 * @request GET:/organization/{id}/processes/doc
	 * @secure
	 */
	processesDocDetail = (id: number, params: RequestParams = {}) =>
		this.request<File, void>({
			path: `/organization/${id}/processes/doc`,
			method: "GET",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Бизнес-процессы
	 * @summary Загрузить утвержденную версию БП
	 * @request POST:/organization/{id}/processes/doc
	 * @secure
	 */
	processesDocCreate = (
		id: number,
		data: {
			/** @format binary */
			file?: File;
		},
		params: RequestParams = {},
	) =>
		this.request<void, void>({
			path: `/organization/${id}/processes/doc`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.FormData,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Бизнес-процессы
	 * @summary Печать документа
	 * @request GET:/organization/{id}/processes/doc/print
	 * @secure
	 */
	processesDocPrintDetail = (id: number, params: RequestParams = {}) =>
		this.request<Application, void>({
			path: `/organization/${id}/processes/doc/print`,
			method: "GET",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Объекты организаций
	 * @summary Список объектов организации
	 * @request GET:/organization/{id}/objects
	 * @secure
	 */
	objectsDetail = (
		id: number,
		query: {
			/**
			 * part
			 * @format int32
			 */
			part: number;
			/**
			 * count
			 * @format int32
			 */
			count: number;
			/** Поисковый запрос. Поиск осуществляется по полям кода и наименование объекта */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<OrganizationObjectResponse[], void>({
			path: `/organization/${id}/objects`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Объекты организаций
	 * @summary Список объектов организации с утвержденными моделями угроз
	 * @request GET:/organization/{id}/threat/objects
	 * @secure
	 */
	threatObjectsDetail = (
		id: number,
		query: {
			/**
			 * part
			 * @format int32
			 */
			part: number;
			/**
			 * count
			 * @format int32
			 */
			count: number;
		},
		params: RequestParams = {},
	) =>
		this.request<OrganizationObjectDocumentResponse[], void>({
			path: `/organization/${id}/threat/objects`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Объекты организаций
	 * @summary Список объектов организации с загруженными документами-основаниями
	 * @request GET:/organization/{id}/objects/docs
	 * @secure
	 */
	objectsDocsDetail = (
		id: number,
		query: {
			/**
			 * part
			 * @format int32
			 */
			part: number;
			/**
			 * count
			 * @format int32
			 */
			count: number;
		},
		params: RequestParams = {},
	) =>
		this.request<OrganizationObjectDocumentResponse[], void>({
			path: `/organization/${id}/objects/docs`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Объекты организаций
	 * @summary Добавление объекта организации
	 * @request POST:/organization/{id}/object
	 * @secure
	 */
	objectCreate = (
		id: number,
		data: {
			params?: OrganizationObjectParams;
			/** @format binary */
			file?: File;
		},
		params: RequestParams = {},
	) =>
		this.request<OrganizationObjectResponse, void>({
			path: `/organization/${id}/object`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.FormData,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Объекты организаций
	 * @summary Редактирование объекта организации
	 * @request PUT:/organization/object/{id}
	 * @secure
	 */
	objectUpdate = (
		id: number,
		data: {
			params?: OrganizationObjectParams;
			/** @format binary */
			file?: File;
		},
		params: RequestParams = {},
	) =>
		this.request<OrganizationObjectResponse, void>({
			path: `/organization/object/${id}`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.FormData,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Объекты организаций
	 * @summary Удаление объекта организации
	 * @request DELETE:/organization/object/{id}
	 * @secure
	 */
	objectDelete = (id: number, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/organization/object/${id}`,
			method: "DELETE",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Объекты организаций
	 * @summary Получить список подключенных и неподключенных бизнес-процессов
	 * @request GET:/organization/{id}/object/{objectID}/processes
	 * @secure
	 */
	objectProcessesDetail = (id: number, objectId: number, params: RequestParams = {}) =>
		this.request<BusinessProcessInfoResponse[], void>({
			path: `/organization/${id}/object/${objectId}/processes`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Объекты организаций
	 * @summary Привязать объект организации к бизнес-процессам
	 * @request POST:/organization/{id}/object/{objectID}/process
	 * @secure
	 */
	objectProcessCreate = (id: number, objectId: number, data: ProcessParams, params: RequestParams = {}) =>
		this.request<OrganizationObjectResponse, void>({
			path: `/organization/${id}/object/${objectId}/process`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Объекты организаций
	 * @summary Получение документа-основания объекта организации
	 * @request GET:/organization/object/document/{id}
	 * @secure
	 */
	objectDocumentDetail = (id: number, params: RequestParams = {}) =>
		this.request<File, void>({
			path: `/organization/object/document/${id}`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Объекты организаций
	 * @summary Зафиксировать действие над документом (печать)
	 * @request GET:/organization/object/document/{id}/touch
	 * @secure
	 */
	objectDocumentTouchDetail = (id: number, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/organization/object/document/${id}/touch`,
			method: "GET",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Просмотр файла ФСТЭК
	 * @request GET:/organization/object/{id}/document
	 * @originalName objectDocumentDetail
	 * @duplicate
	 * @secure
	 */
	objectDocumentDetail2 = (id: number, params: RequestParams = {}) =>
		this.request<File, void>({
			path: `/organization/object/${id}/document`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Объекты организаций
	 * @summary Загрузка документа-основания в объект организации
	 * @request POST:/organization/object/{id}/document
	 * @secure
	 */
	objectDocumentCreate = (
		id: number,
		data: {
			/** @format binary */
			file?: File;
		},
		params: RequestParams = {},
	) =>
		this.request<OrganizationObjectResponse, void>({
			path: `/organization/object/${id}/document`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.FormData,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Получить объект организации
	 * @request GET:/organization/object/{id}/threat
	 * @secure
	 */
	objectThreatDetail = (id: number, params: RequestParams = {}) =>
		this.request<OrganizationObjectThreatResponse, void>({
			path: `/organization/object/${id}/threat`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Получение списка для формирования модели угроз
	 * @request GET:/organization/{id}/threats
	 * @secure
	 */
	threatsDetail = (
		id: number,
		query?: {
			/**
			 * Партия
			 * @format int32
			 */
			part?: number;
			/**
			 * Количество
			 * @format int32
			 */
			count?: number;
			/** Фильтр списка */
			filter?: string;
			/** Фильтр заполненности */
			status?: string;
			/** Колонка таблицы для сортировки */
			order_column?: string;
			/** Значение (ASC - по возрастанию, DESC - по убыванию) */
			order_value?: string;
			/** Поисковый запрос */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<OrganizationObjectThreatResponse[], void>({
			path: `/organization/${id}/threats`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * @description true - не заполнены все поля, false - заполнены
	 *
	 * @tags Формирование модели угроз
	 * @summary Проверка заполненности модели угроз
	 * @request GET:/organization/{id}/threats/verify
	 * @secure
	 */
	threatsVerifyDetail = (id: number, params: RequestParams = {}) =>
		this.request<boolean, void>({
			path: `/organization/${id}/threats/verify`,
			method: "GET",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Получить статус заполненности таблиц
	 * @request GET:/organization/object/{id}/status/fill
	 * @secure
	 */
	objectStatusFillDetail = (
		id: number,
		query?: {
			/** Таблица */
			tab?:
				| "SYSTEM"
				| "RISK"
				| "INFLUENCE"
				| "COLLUSION"
				| "ASSESSMENT"
				| "LEVEL"
				| "VIOLATOR"
				| "WAY"
				| "TACTIC"
				| "ACTUAL";
		},
		params: RequestParams = {},
	) =>
		this.request<ThreatFillStatusResponse[], void>({
			path: `/organization/object/${id}/status/fill`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Получение описания системы
	 * @request GET:/organization/object/{id}/system
	 * @secure
	 */
	objectSystemDetail = (id: number, params: RequestParams = {}) =>
		this.request<SystemDescriptionResponse, void>({
			path: `/organization/object/${id}/system`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Сохранение описания системы
	 * @request POST:/organization/object/{id}/system
	 * @secure
	 */
	objectSystemCreate = (id: number, data: SystemDescriptionParams, params: RequestParams = {}) =>
		this.request<SystemDescriptionResponse, void>({
			path: `/organization/object/${id}/system`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Получение загруженного изображения
	 * @request GET:/organization/object/{id}/system/picture
	 * @secure
	 */
	objectSystemPictureDetail = (
		id: number,
		query: {
			/** Какую картинку скачать */
			target: "ARCHITECTURE" | "STRUCTURE";
		},
		params: RequestParams = {},
	) =>
		this.request<File, void>({
			path: `/organization/object/${id}/system/picture`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Загрузить изображение
	 * @request POST:/organization/object/{id}/system/picture
	 * @secure
	 */
	objectSystemPictureCreate = (
		id: number,
		query: {
			/** В какой раздел загружать */
			target: "ARCHITECTURE" | "STRUCTURE";
		},
		data: {
			/** @format binary */
			file?: File;
		},
		params: RequestParams = {},
	) =>
		this.request<File, void>({
			path: `/organization/object/${id}/system/picture`,
			method: "POST",
			query: query,
			body: data,
			secure: true,
			type: ContentType.FormData,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Получить список технических средств систем
	 * @request GET:/organization/object/system/{id}/means
	 * @secure
	 */
	objectSystemMeansDetail = (
		id: number,
		query: {
			/**
			 * Партия
			 * @format int32
			 */
			part: number;
			/**
			 * Количество
			 * @format int32
			 */
			count: number;
		},
		params: RequestParams = {},
	) =>
		this.request<SystemMeanResponse[], void>({
			path: `/organization/object/system/${id}/means`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Добавить техническое средство системы
	 * @request POST:/organization/object/{id}/system/means
	 * @secure
	 */
	objectSystemMeansCreate = (id: number, data: SystemMeanParams, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/organization/object/${id}/system/means`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Редактировать техническое описание системы
	 * @request PUT:/organization/object/system/mean/{id}
	 * @secure
	 */
	objectSystemMeanUpdate = (id: number, data: SystemMeanEditParams, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/organization/object/system/mean/${id}`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.Json,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Удалить техническое описание
	 * @request DELETE:/organization/object/system/mean/{id}
	 * @secure
	 */
	objectSystemMeanDelete = (id: number, params: RequestParams = {}) =>
		this.request<SystemMeanResponse, void>({
			path: `/organization/object/system/mean/${id}`,
			method: "DELETE",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Получить список описаний групп пользователя
	 * @request GET:/organization/object/{id}/system/groups
	 * @secure
	 */
	objectSystemGroupsDetail = (id: number, params: RequestParams = {}) =>
		this.request<UserGroupResponse[], void>({
			path: `/organization/object/${id}/system/groups`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Добавить описание группы пользователя
	 * @request POST:/organization/object/{id}/system/groups
	 * @secure
	 */
	objectSystemGroupsCreate = (id: number, data: UserGroupParams, params: RequestParams = {}) =>
		this.request<UserGroupResponse, void>({
			path: `/organization/object/${id}/system/groups`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Редактирование описания группы пользователя
	 * @request PUT:/organization/object/system/group/{id}
	 * @secure
	 */
	objectSystemGroupUpdate = (id: number, data: UserGroupParams, params: RequestParams = {}) =>
		this.request<UserGroupResponse, void>({
			path: `/organization/object/system/group/${id}`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Удаление описания группы пользователя
	 * @request DELETE:/organization/object/system/group/{id}
	 * @secure
	 */
	objectSystemGroupDelete = (id: number, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/organization/object/system/group/${id}`,
			method: "DELETE",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Получение списка видов рисков и негативных последствий
	 * @request GET:/organization/object/{id}/risk
	 * @secure
	 */
	objectRiskDetail = (id: number, params: RequestParams = {}) =>
		this.request<RiskTypeResponse[], void>({
			path: `/organization/object/${id}/risk`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Сохранение вида риска и негативного последствия
	 * @request PUT:/organization/object/risk/{id}
	 * @secure
	 */
	objectRiskUpdate = (id: number, data: RiskTypeParams, params: RequestParams = {}) =>
		this.request<RiskTypeResponse, void>({
			path: `/organization/object/risk/${id}`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Получение списка объектов воздействия (видов воздействия)
	 * @request GET:/organization/object/{id}/influence
	 * @secure
	 */
	objectInfluenceDetail = (id: number, params: RequestParams = {}) =>
		this.request<InfluenceObjectResponse[], void>({
			path: `/organization/object/${id}/influence`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Добавление объекта воздействия (вида воздействия)
	 * @request POST:/organization/object/{id}/influence
	 * @secure
	 */
	objectInfluenceCreate = (id: number, data: InfluenceObjectParams, params: RequestParams = {}) =>
		this.request<InfluenceObjectResponse, void>({
			path: `/organization/object/${id}/influence`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Редактирование объекта воздействия (вида воздействия)
	 * @request PUT:/organization/object/influence/{id}
	 * @secure
	 */
	objectInfluenceUpdate = (id: number, data: InfluenceObjectParams, params: RequestParams = {}) =>
		this.request<InfluenceObjectResponse, void>({
			path: `/organization/object/influence/${id}`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Удаление объекта воздействия (вида воздействия)
	 * @request DELETE:/organization/object/influence/{id}
	 * @secure
	 */
	objectInfluenceDelete = (id: number, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/organization/object/influence/${id}`,
			method: "DELETE",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Получить список групп сговора
	 * @request GET:/organization/object/{id}/collusion
	 * @secure
	 */
	objectCollusionDetail = (id: number, params: RequestParams = {}) =>
		this.request<CollusionGroupResponse[], void>({
			path: `/organization/object/${id}/collusion`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Добавление группы сговора
	 * @request POST:/organization/object/{id}/collusion
	 * @secure
	 */
	objectCollusionCreate = (id: number, data: CollusionGroupParams, params: RequestParams = {}) =>
		this.request<CollusionGroupResponse, void>({
			path: `/organization/object/${id}/collusion`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Редактирование группы сговора
	 * @request PUT:/organization/object/collusion/{id}
	 * @secure
	 */
	objectCollusionUpdate = (id: number, data: CollusionGroupParams, params: RequestParams = {}) =>
		this.request<CollusionGroupResponse, void>({
			path: `/organization/object/collusion/${id}`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Удаление группы сговора
	 * @request DELETE:/organization/object/collusion/{id}
	 * @secure
	 */
	objectCollusionDelete = (id: number, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/organization/object/collusion/${id}`,
			method: "DELETE",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Список оценок целей реализации угроз
	 * @request GET:/organization/object/{id}/assessment
	 * @secure
	 */
	objectAssessmentDetail = (id: number, params: RequestParams = {}) =>
		this.request<ThreatImplementationAssessmentResponse[], void>({
			path: `/organization/object/${id}/assessment`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Добавление оценки целей реализации угроз
	 * @request POST:/organization/object/{id}/assessment
	 * @secure
	 */
	objectAssessmentCreate = (id: number, data: ThreatImplementationAssessmentParams, params: RequestParams = {}) =>
		this.request<ThreatImplementationAssessmentResponse, void>({
			path: `/organization/object/${id}/assessment`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Редактирование оценки целей реализации угроз
	 * @request PUT:/organization/object/assessment/{id}
	 * @secure
	 */
	objectAssessmentUpdate = (id: number, data: ThreatImplementationAssessmentParams, params: RequestParams = {}) =>
		this.request<ThreatImplementationAssessmentResponse, void>({
			path: `/organization/object/assessment/${id}`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Удаление оценки целей реализации угроз
	 * @request DELETE:/organization/object/assessment/{id}
	 * @secure
	 */
	objectAssessmentDelete = (id: number, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/organization/object/assessment/${id}`,
			method: "DELETE",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Получить список уровней возможностей нарушителей
	 * @request GET:/organization/object/{id}/level
	 * @secure
	 */
	objectLevelDetail = (id: number, params: RequestParams = {}) =>
		this.request<ThreatImplementationLevelResponse[], void>({
			path: `/organization/object/${id}/level`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Добавить уровень возможностей нарушителей
	 * @request POST:/organization/object/{id}/level
	 * @secure
	 */
	objectLevelCreate = (id: number, data: ThreatImplementationLevelParams, params: RequestParams = {}) =>
		this.request<ThreatImplementationLevelResponse[], void>({
			path: `/organization/object/${id}/level`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Редактировать уровень возможностей нарушителей
	 * @request PUT:/organization/object/level/{id}
	 * @secure
	 */
	objectLevelUpdate = (id: number, data: ThreatImplementationLevelUpdateParams, params: RequestParams = {}) =>
		this.request<ThreatImplementationLevelResponse, void>({
			path: `/organization/object/level/${id}`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Удалить уровень возможностей нарушителей
	 * @request DELETE:/organization/object/level/{id}
	 * @secure
	 */
	objectLevelDelete = (id: number, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/organization/object/level/${id}`,
			method: "DELETE",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Получить список актуальных нарушителей
	 * @request GET:/organization/object/{id}/violator
	 * @secure
	 */
	objectViolatorDetail = (id: number, params: RequestParams = {}) =>
		this.request<ActualViolatorResponse[], void>({
			path: `/organization/object/${id}/violator`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Добавить актуального нарушителя
	 * @request POST:/organization/object/{id}/violator
	 * @secure
	 */
	objectViolatorCreate = (id: number, data: ActualViolatorParams, params: RequestParams = {}) =>
		this.request<ActualViolatorResponse, void>({
			path: `/organization/object/${id}/violator`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Редактировать актуального нарушителя
	 * @request PUT:/organization/object/violator/{id}
	 * @secure
	 */
	objectViolatorUpdate = (id: number, data: ActualViolatorParams, params: RequestParams = {}) =>
		this.request<ActualViolatorResponse, void>({
			path: `/organization/object/violator/${id}`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Удалить актуального нарушителя
	 * @request DELETE:/organization/object/violator/{id}
	 * @secure
	 */
	objectViolatorDelete = (id: number, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/organization/object/violator/${id}`,
			method: "DELETE",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Получить список актуальных способов реализации угроз
	 * @request GET:/organization/object/{id}/way
	 * @secure
	 */
	objectWayDetail = (id: number, params: RequestParams = {}) =>
		this.request<ImplementThreatWayResponse[], void>({
			path: `/organization/object/${id}/way`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Добавить актуальный способ реализации угроз
	 * @request POST:/organization/object/{id}/way
	 * @secure
	 */
	objectWayCreate = (id: number, data: ImplementThreatWayParams, params: RequestParams = {}) =>
		this.request<ImplementThreatWayResponse, void>({
			path: `/organization/object/${id}/way`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Редактировать актуальный способ реализации угроз
	 * @request PUT:/organization/object/way/{id}
	 * @secure
	 */
	objectWayUpdate = (id: number, data: ImplementThreatWayParams, params: RequestParams = {}) =>
		this.request<ImplementThreatWayResponse, void>({
			path: `/organization/object/way/${id}`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Удалить актуальный способ реализации угроз
	 * @request DELETE:/organization/object/way/{id}
	 * @secure
	 */
	objectWayDelete = (id: number, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/organization/object/way/${id}`,
			method: "DELETE",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Получить список основных тактик и техник
	 * @request GET:/organization/object/{id}/tactic
	 * @secure
	 */
	objectTacticDetail = (id: number, params: RequestParams = {}) =>
		this.request<BasicTacticResponse[], void>({
			path: `/organization/object/${id}/tactic`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Получить список идентификаторов тактик
	 * @request GET:/organization/object/{id}/tactic/short
	 * @secure
	 */
	objectTacticShortDetail = (id: number, params: RequestParams = {}) =>
		this.request<String[], void>({
			path: `/organization/object/${id}/tactic/short`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Получение списка актуальных угроз
	 * @request GET:/organization/object/{id}/threats/actual
	 * @secure
	 */
	objectThreatsActualDetail = (id: number, params: RequestParams = {}) =>
		this.request<ActualThreatResponse[], void>({
			path: `/organization/object/${id}/threats/actual`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Добавление актуальной угрозы
	 * @request POST:/organization/object/{id}/threats/actual
	 * @secure
	 */
	objectThreatsActualCreate = (id: number, data: ActualThreatParams, params: RequestParams = {}) =>
		this.request<ActualThreatResponse, void>({
			path: `/organization/object/${id}/threats/actual`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Редактирование актуальной угрозы
	 * @request PUT:/organization/object/threats/actual/{id}
	 * @secure
	 */
	objectThreatsActualUpdate = (id: number, data: ActualThreatUpdateParams, params: RequestParams = {}) =>
		this.request<ActualThreatResponse, void>({
			path: `/organization/object/threats/actual/${id}`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Удаление актуальной угрозы
	 * @request DELETE:/organization/object/threats/actual/{id}
	 * @secure
	 */
	objectThreatsActualDelete = (id: number, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/organization/object/threats/actual/${id}`,
			method: "DELETE",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Импорт файла ФСТЭК
	 * @request POST:/organization/object/{id}/documents
	 * @secure
	 */
	objectDocumentsCreate = (
		id: number,
		query: {
			/** Использовать детальные данные */
			detail: boolean;
		},
		data: {
			/** @format binary */
			file?: File;
		},
		params: RequestParams = {},
	) =>
		this.request<ActualThreatResponse[], void>({
			path: `/organization/object/${id}/documents`,
			method: "POST",
			query: query,
			body: data,
			secure: true,
			type: ContentType.FormData,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Получение файла модели угроз для утверждения
	 * @request GET:/organization/object/{id}/document/verify
	 * @secure
	 */
	objectDocumentVerifyDetail = (id: number, params: RequestParams = {}) =>
		this.request<File, void>({
			path: `/organization/object/${id}/document/verify`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Загрузка утвержденного файла модели угроз
	 * @request POST:/organization/object/{id}/document/verify
	 * @secure
	 */
	objectDocumentVerifyCreate = (
		id: number,
		query: {
			/** @format int32 */
			userID: number;
		},
		data: {
			/** @format binary */
			file?: File;
		},
		params: RequestParams = {},
	) =>
		this.request<void, void>({
			path: `/organization/object/${id}/document/verify`,
			method: "POST",
			query: query,
			body: data,
			secure: true,
			type: ContentType.FormData,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Сохранить настройки как шаблон модели угроз (с заменой по имени)
	 * @request PUT:/organization/object/{id}/threat-model-template/save
	 * @secure
	 */
	objectThreatModelTemplateSaveUpdate = (
		id: number,
		data: ThreatModelTemplateCreateRequest,
		params: RequestParams = {},
	) =>
		this.request<ThreatModelTemplateResponse, void>({
			path: `/organization/object/${id}/threat-model-template/save`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Сохранить настройки как шаблон модели угроз
	 * @request POST:/organization/object/{id}/threat-model-template/save
	 * @secure
	 */
	objectThreatModelTemplateSaveCreate = (
		id: number,
		data: ThreatModelTemplateCreateRequest,
		params: RequestParams = {},
	) =>
		this.request<ThreatModelTemplateResponse, void | String[]>({
			path: `/organization/object/${id}/threat-model-template/save`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Список применимых шаблонов модели угроз
	 * @request GET:/organization/object/{id}/threat-model-template/list
	 * @secure
	 */
	objectThreatModelTemplateListDetail = (
		id: number,
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<ThreatModelTemplateResponse[], void>({
			path: `/organization/threat-model-template/list`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Формирование модели угроз
	 * @summary Применить шаблон модели угроз
	 * @request GET:/organization/object/{id}/threat-model-template/{template_id}/apply
	 * @secure
	 */
	objectThreatModelTemplateApplyDetail = (body:{objects:number[],templateId:number}, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/organization/threat-model-template/apply`,
			method: "POST",
			body,
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Расчет экономического ущерба
	 * @summary Получить значения и результаты формул
	 * @request GET:/organization/object/{id}/damage
	 * @secure
	 */
	objectDamageDetail = (
		id: number,
		query?: {
			/**
			 * id адреса
			 * @format int32
			 */
			locationID?: number;
		},
		params: RequestParams = {},
	) =>
		this.request<EconomicalDamageResponse[], void>({
			path: `/organization/object/${id}/damage`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Расчет экономического ущерба
	 * @summary Добавить значения формул
	 * @request POST:/organization/object/{id}/damage
	 * @secure
	 */
	objectDamageCreate = (
		id: number,
		query: {
			type:
				| "INDEX_EIGHT"
				| "INDEX_NINE"
				| "K_NP"
				| "D_NDPI"
				| "K_NDPI"
				| "D_DIV"
				| "K_NS"
				| "D_VSO"
				| "B_MIDDLE"
				| "INDEX_TEN";
		},
		data: EconomicalDamageParams,
		params: RequestParams = {},
	) =>
		this.request<EconomicalDamageResponse, void>({
			path: `/organization/object/${id}/damage`,
			method: "POST",
			query: query,
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Расчет экономического ущерба
	 * @summary Завершить расчет
	 * @request POST:/organization/object/{id}/summary
	 * @secure
	 */
	objectSummaryCreate = (id: number, params: RequestParams = {}) =>
		this.request<DamageObjectResponse, void>({
			path: `/organization/object/${id}/summary`,
			method: "POST",
			secure: true,
			format: "json",
			...params,
		});
}
export const organizationAPI = new Organization();
